export const filterAndSortRequests = (requests, statusFilter, sortBy) => {
  // Filter requests
  const filteredRequests = requests.filter(request =>
    statusFilter === 'All' || request.status.toLowerCase() === statusFilter.toLowerCase()
  );

  // Sort requests
  return [...filteredRequests].sort((a, b) => {
    switch (sortBy) {
      case 'createdAt':
        return new Date(b.createdAt) - new Date(a.createdAt);
      case 'borrowDate':
        return new Date(a.requestedDates[0].startDate) - new Date(b.requestedDates[0].startDate);
      case 'toolName':
        return a.toolName.localeCompare(b.toolName);
      default:
        return 0;
    }
  });
};

export const getStatusColor = (status) => {
  switch (status.toLowerCase()) {
    case 'approved':
      return 'bg-green-100 text-green-800 border-green-200';
    case 'declined':
      return 'bg-red-100 text-red-800 border-red-200';
    case 'cancelled':
      return 'bg-gray-100 text-gray-800 border-gray-200';
    default:
      return 'bg-yellow-100 text-yellow-800 border-yellow-200';
  }
};
